import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { validUsername } from '@/utils/validate';
import { setTheme } from '@/utils/auth';
import Vue from "vue";
export default {
  name: 'Login',
  data: function data() {
    // eslint-disable-next-line no-unused-vars
    var validateUsername = function validateUsername(rule, value, callback) {
      if (!validUsername(value)) {
        callback(new Error('Please enter the correct user name'));
      } else {
        callback();
      }
    };
    // eslint-disable-next-line no-unused-vars
    var validatePassword = function validatePassword(rule, value, callback) {
      if (value.length < 6) {
        callback(new Error('The password can not be less than 6 digits'));
      } else {
        callback();
      }
    };
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [{
          required: true,
          trigger: 'blur',
          message: '请输入用户ID'
        }],
        password: [
        // { required: true, trigger: "blur", validator: validatePassword }
        {
          required: true,
          trigger: 'blur',
          message: '请输入密码'
        }]
      },
      loading: false,
      passwordType: 'password',
      redirect: undefined,
      checked: false,
      theme: process.env.VUE_APP_theme
    };
  },
  watch: {
    $route: {
      handler: function handler(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    }
  },
  methods: {
    showPwd: function showPwd() {
      var _this = this;
      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }
      this.$nextTick(function () {
        _this.$refs.password.focus();
      });
    },
    handleLogin: function handleLogin() {
      var _this2 = this;
      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          _this2.loading = true;
          _this2.$store.dispatch('user/login', _this2.loginForm).then(function () {
            _this2.$API.getRequest({
              url: '/platform/global/config',
              data: {
                systemId: 'LC_PLATFORM'
              }
            }).then(function (res) {
              res.result.forEach(function (element) {
                if (element.bindDictCode === 'THEME') {
                  setTheme(element.value.configKey);
                }
              });
            });
            _this2.$API.getRequest({
              url: '/platform/component/rootOrgIdList'
            }).then(function (res) {
              if (res.code === '0000000000') {
                Vue.prototype.$HEXASINO.rootOrgId = res.result.records.map(function (item) {
                  return item.orgId;
                });
              }
            });
            _this2.$router.push({
              path: '/'
            });
            _this2.loading = false;
          }).catch(function () {
            _this2.loading = false;
          });
        } else {
          return false;
        }
      });
    }
  }
};